import * as React from "react";
import { Tabs, TabsProps } from "antd";
import { fileDetailsStore } from "./FileDetailsStore";
import { Details } from "./Components/Details";
import { Metadata } from "./Components/Metadata";
import { observer } from "mobx-react";
import { Versions } from "./Components/Versions";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Information } from "./Components/Information";
import { Loader } from "Components/General/Loader";
import { LogSummary } from "./Components/LogSummary";
import { userInfoStore } from "Stores";
import { TaskState } from "./Components/TaskState";
import { Relations } from "./Components/Relations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { documentsTableStore } from "Pages/Project/Documents/Stores/DocumentsTableStore";
import { documentsSearchStore } from "Pages/Project/Documents/Stores/DocumentsSearchStore";
import { isEmpty } from "lodash";
import classnames from "classnames";
import { Notarization } from "./Components/Notarization";
import { Modal } from "Components/General/Modal/GenericModal";

interface FileDetailsModalProps extends WithTranslation {}

interface FileDetailsModalState {
  activeKey: string;
}

export const FileDetailsModal = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<FileDetailsModalProps, FileDetailsModalState> {
      constructor(props: FileDetailsModalProps) {
        super(props);

        this.state = {
          activeKey: "1",
        };
      }

      handleTabChange = (activeKey: string) => {
        this.setState({ activeKey });
      };

      handleCancel = () => {
        fileDetailsStore.toggleModal();
        fileDetailsStore.clear();
        this.setState({ activeKey: "1" });
      };

      inRange = (x: number) => {
        const filesLength = this.files.length;
        return x >= 0 && x < filesLength;
      };

      onArrowPress = (isForward: boolean) => {
        const nextIndex = this.currentItemIndex + (isForward ? 1 : -1);
        if (this.inRange(nextIndex))
          fileDetailsStore.initModal(this.files[nextIndex].parentId, this.files[nextIndex].id, {
            from: "documents",
            linkId: this.files[nextIndex].state === "EXTERN_SYMLINK" && this.files[nextIndex].linkId,
          });
      };

      get files() {
        return isEmpty(documentsSearchStore.data)
          ? documentsTableStore.files
          : documentsSearchStore.data.filter((item) => !("isGroup" in item));
      }

      get currentItemIndex() {
        return this.files.findIndex((item) => item.id === fileDetailsStore.data?.id);
      }

      get tabItems() {
        const { t } = this.props;
        const tabPanes: TabsProps["items"] = [
          {
            key: "1",
            label: t("File details", { defaultValue: "Details" }),
            children: <Details />,
          },
        ];

        const isExternLink = (fileDetailsStore.data as API_ExternalLinked)?.parentProjectId;
        if (!isExternLink) {
          tabPanes.push({
            key: "2",
            label: t("Versions"),
            children: <Versions />,
          });
        }

        if (fileDetailsStore.data?.properties) {
          if (fileDetailsStore.data.properties.metadata) {
            tabPanes.push({
              key: "3",
              label: t("Metadata"),
              children: <Metadata />,
            });
          }
          if (fileDetailsStore.data.properties.accessHistory) {
            tabPanes.push({
              key: "4",
              label: t("Info knowledge"),
              children: <Information />,
            });
          }
          if (fileDetailsStore.data.properties.log) {
            tabPanes.push({
              key: "5",
              label: t("Total protocol"),
              children: <LogSummary />,
            });
          }
        }
        if (!isExternLink) {
          tabPanes.push({
            key: "Relations",
            label: t("Relations"),
            children: <Relations />,
          });
        }

        if (fileDetailsStore.data?.hasDocnodesInfo) {
          tabPanes.push({
            key: "6",
            label: t("Notarization"),
            children: <Notarization />,
          });
        }
        if (userInfoStore.role === "ADMIN" && !isExternLink) {
          tabPanes.push({
            key: "7",
            label: t("Technical Info"),
            children: <TaskState />,
          });
        }

        return tabPanes;
      }

      render() {
        const { t } = this.props;
        return (
          <Modal
            style={{ maxWidth: 1200 }}
            width={"100%"}
            footer={null}
            title={
              fileDetailsStore.state === "LOADING" ? t("Loading...") : `${t("File")} "${fileDetailsStore.data.name} "`
            }
            open={fileDetailsStore.isVisible}
            destroyOnHidden={true}
            onCancel={this.handleCancel}
            zIndex={1010}
          >
            {fileDetailsStore.state === "LOADING" ? (
              <Loader />
            ) : (
              <>
                {fileDetailsStore.from === "documents" ? (
                  <>
                    <FontAwesomeIcon
                      className={classnames("file-details-arrow", {
                        "is-hidden": !this.inRange(this.currentItemIndex - 1),
                      })}
                      style={{ left: 5 }}
                      icon={["fal", "chevron-left"]}
                      size="4x"
                      onClick={() => this.onArrowPress(false)}
                    />
                    <FontAwesomeIcon
                      className={classnames("file-details-arrow", {
                        "is-hidden": !this.inRange(this.currentItemIndex + 1),
                      })}
                      style={{ right: 5, zIndex: 100 }}
                      icon={["fal", "chevron-right"]}
                      size="4x"
                      onClick={() => this.onArrowPress(true)}
                    />
                  </>
                ) : null}
                <Tabs activeKey={this.state.activeKey} onChange={this.handleTabChange} items={this.tabItems} />
              </>
            )}
          </Modal>
        );
      }
    }
  )
);
